import { render, staticRenderFns } from "./SearchAgent.vue?vue&type=template&id=7884eb60&scoped=true"
import script from "./SearchAgent.vue?vue&type=script&lang=js"
export * from "./SearchAgent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7884eb60",
  null
  
)

export default component.exports